module.exports = __webpack_public_path__ + "img/close.d8c9eb96.svg";